import type { ReactNode } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { cn } from "@/lib/utils/cn";

interface GhostMobileDisclosureProps {
  collapsedLabel: string;
  expandedLabel?: string;
  children: ReactNode;
  className?: string;
  summaryClassName?: string;
  contentClassName?: string;
}

export default function GhostMobileDisclosure({
  collapsedLabel,
  expandedLabel,
  children,
  className,
  summaryClassName,
  contentClassName,
}: GhostMobileDisclosureProps) {
  return (
    <details
      className={cn(
        "group rounded-[22px] border border-white/10 bg-black/20 px-4 py-3",
        className,
      )}
    >
      <summary
        className={cn(
          "flex cursor-pointer list-none items-center justify-between gap-4 text-left [&::-webkit-details-marker]:hidden [&::marker]:hidden",
          summaryClassName,
        )}
      >
        <span className="text-sm font-semibold uppercase tracking-[0.14em] text-ghost-gold transition-colors group-open:text-white">
          <span className="group-open:hidden">{collapsedLabel}</span>
          <span className="hidden group-open:inline">
            {expandedLabel ?? collapsedLabel}
          </span>
        </span>

        <span className="text-ghost-gold" aria-hidden="true">
          <FaChevronDown className="group-open:hidden" size={14} />
          <FaChevronUp className="hidden group-open:block" size={14} />
        </span>
      </summary>

      <div className={cn("pt-4", contentClassName)}>{children}</div>
    </details>
  );
}
